import { getLogger } from '@blueberry/observability'
import { safeJsonParse, unescapejs } from '@blueberry/utils'
import { Controller } from '@hotwired/stimulus'

type Condition = { question_id: string; answer_id: string }

const logger = getLogger('balance-medical-history-form')

export default class extends Controller {
  declare questionTargets: HTMLElement[]
  static targets = ['question']

  connect() {
    document.body.scrollIntoView({ block: 'start' })
    this.updateQuestionVisibility()
  }

  inputChanged() {
    this.updateQuestionVisibility()
  }

  updateQuestionVisibility() {
    this.questionTargets.forEach((question) => {
      const when = safeJsonParse<Condition[]>(
        unescapejs(question.dataset.when ?? '[]'),
      )

      if (!when) {
        logger.error('No existing when for question', question)
        return
      }

      const inputs = question.querySelectorAll('input,select,textarea')

      const shouldShow =
        when.length === 0 || when.every(this.isConditionMet.bind(this))

      if (shouldShow) {
        question.style.display = 'block'
        inputs.forEach((input) => {
          input.removeAttribute('disabled')
        })
      } else {
        question.style.display = 'none'
        inputs.forEach((input) => {
          input.setAttribute('disabled', 'disabled')
        })
      }
    })
  }

  isConditionMet(when: Condition) {
    const dependentInput = this.element.querySelector(
      `[name="question_${when.question_id}"]:not([type="hidden"])`,
    )

    if (!dependentInput) {
      logger.warn('No dependent input found for question', when.question_id)
      return true
    }

    if (
      dependentInput instanceof HTMLInputElement &&
      (dependentInput.type === 'radio' || dependentInput.type === 'checkbox')
    ) {
      const dependentCheckbox = this.element.querySelector(
        `[name="question_${when.question_id}"][value="${when.answer_id}"]`,
      )

      if (
        !dependentCheckbox ||
        !(dependentCheckbox instanceof HTMLInputElement)
      ) {
        logger.warn(
          'No dependent input found for question',
          when.question_id,
          when.answer_id,
        )
        return true
      }

      return (
        dependentCheckbox.checked && dependentCheckbox.value === when.answer_id
      )
    }

    if (
      dependentInput instanceof HTMLSelectElement &&
      dependentInput.tagName === 'SELECT'
    ) {
      return dependentInput.value === when.answer_id
    }

    logger.error('Unsupported input type', when, dependentInput)

    return true
  }
}
